import { Routes } from '@angular/router';
import { canActivateAuthorization } from '../security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../core/base-api';
import { NeskoabSucheComponent } from './neskoab-suche/neskoab-suche.component';
import { canActivateErweiterung } from 'app/security/erweiterung.guard';
import { NeskoabDetailComponent } from './neskoab-detail/neskoab-detail.component';
import { NeskoabDetailResolver } from './neskoab-detail-resolver';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { NeskoabViewmodelService } from './neskoab-viewmodel.service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const NeskoabRoutes: Routes = [
  {
    path: 'neskoab',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.ANZEIGE_SPEZNESKO_GRUNDSTUECK]
    },
    children: [
      {
        path: '',
        loadChildren: () => routes,
        providers: [NeskoabViewmodelService, NeskoabDetailResolver]
      }
    ]
  }
];

const routes: Routes = [
  {
    path: '',
    component: NeskoabSucheComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.ANZEIGE_SPEZNESKO_GRUNDSTUECK],
      erweiterung: [ActiveErweiterungenEnum.NESKO_SCHNITTELLE],
      breadcrumb: 'neskoabSearch.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'detail',
    component: NeskoabDetailComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.ANZEIGE_SPEZNESKO_GRUNDSTUECK]
    },
    resolve: {
      entity: NeskoabDetailResolver
    },
    runGuardsAndResolvers: 'always'
  }
];
